export const isObject = (object) => Object.prototype.toString.call(object).includes('Object')
export const isArray = (array) => Object.prototype.toString.call(array).includes('Array')
export const isFile = (file) => Object.prototype.toString.call(file).includes('File')
export const isBoolean = (value) => Object.prototype.toString.call(value).includes('Boolean')
export const isString = (string) => Object.prototype.toString.call(string).includes('String')
